import { useContext } from 'react';
import type { FeatureFlag } from '@/enums/feature-flag';
import { FeatureFlagContext } from '@/providers/feature-flag-context';

/**
 * Check if a feature flag is enabled.
 *
 * @param flag - The feature flag to check
 * @returns boolean indicating if the flag is enabled
 *
 * @example
 * const isEnabled = useFeatureFlag(FeatureFlag.SOME_FLAG);
 *
 * @example
 * // Conditional rendering
 * {useFeatureFlag(FeatureFlag.SOME_FLAG) && <Feature />}
 */
export function useFeatureFlag(flag: FeatureFlag): boolean {
  const context = useContext(FeatureFlagContext);

  return context?.isFeatureEnabled(flag) ?? false;
}
